import React from "react";
import SliderMain from "./SliderMain";

const SliderPass = () => {
  const text = [
    "To create a stellar first impression for your new subscribers, Bud offers the welcome email series. The email campaign design involves sending a series of emails. These emails introduce your brand, give a warm welcome, and deliver valuable content. It is also used for enticing incentives to create a bang opening. Bud can help you captivate your targeted audience through this email marketing strategy. Bring your brand to life through our expert email marketing services.",

    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.dignissim enim sit amet. Aliquam  ",

    "Vel pretium lectus quam id leo in vitae. Non tellus orci ac auctor augue mauris augue. Turpis in eu mi bibendum neque egestas congue quisque egestas. Fusce ut placerat orci nulla pellentesque dignissim enim sit amet. Aliquam id diam maecenas ultricies mi eget mauris pharetra. Maecenas sed enim ut sem viverra aliquet eget. Gravida dictum fusce ut placerat orci. Felis eget nunc lobortis mattis aliquam faucibus. dignissim enim sit amet. Aliquam id diam maecenas .",
  ];
  return (
    <div>
      <SliderMain text={text} />
    </div>
  );
};

export default SliderPass;
